'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import ContactForm from './components/ContactForm.vue';

var _class = function _class() {
    _classCallCheck(this, _class);

    Vue.component('contact-form', ContactForm);
};

export default _class;


//////////////////
// WEBPACK FOOTER
// ./resources/templates/semperit/assets/js/modules/contact-form/index.js
// module id = null
// module chunks = 